import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
};

export async function getAppointmentNotificationSettings(token) {
  const res = await axios.get(
    `${API}/online-booking/appointment-notifications/settings`,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function updateAppointmentNotificationSettings(payload, token) {
  const res = await axios.put(
    `${API}/online-booking/appointment-notifications/settings`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}

export async function previewAppointmentNotification(payload, token) {
  const res = await axios.post(
    `${API}/online-booking/appointment-notifications/preview`,
    payload,
    {
      headers: authHeaders(token),
    }
  );
  return res.data;
}
